export default "__VITE_ASSET__BSLj9Y9z__"